import clsx from "clsx";
import { formatDuration } from "../../utils/format-time";
import { TONES, Tone } from "./tones";

export const FAST_MS = 300;
export const SLOW_MS = 1000;
const METER_MAX_MS = 3000;

// ----------------------- LATENCY COLOUR + LABEL ------------------------------------
export function latencyLevel(ms: number | null | undefined): { tone: Tone; label: string } {
  if (ms == null) return { tone: "slate", label: "No timing" };
  if (ms < FAST_MS) return { tone: "emerald", label: "Fast" };
  if (ms <= SLOW_MS) return { tone: "amber", label: "Slow" };
  return { tone: "rose", label: "Very slow" };
}

export function LatencyBadge({ ms, className }: { ms: number | null | undefined; className?: string }) {
  const { tone } = latencyLevel(ms);
  return (
    <span className={clsx("inline-flex items-center rounded-full px-2.5 py-1 font-mono text-[12px] font-semibold tabular-nums", TONES[tone].soft, TONES[tone].text, className)}>
      {formatDuration(ms)}
    </span>
  );
}

export function LatencyMeter({ ms }: { ms: number | null | undefined }) {
  const { tone, label } = latencyLevel(ms);
  const position = ms == null ? 0 : Math.min(100, (ms / METER_MAX_MS) * 100);

  return (
    <div>
      <div className="mb-2 flex items-center justify-between">
        <span className="font-[Gilroy-Medium] text-[13px] text-light-gray">Response time</span>
        <span className={clsx("font-[Gilroy-Bold] text-[13px]", TONES[tone].text)}>{formatDuration(ms)} · {label}</span>
      </div>
      <div className="relative h-2 rounded-full bg-[linear-gradient(90deg,#10b981_0_10%,#f59e0b_10%_33.3%,#f43f5e_33.3%)]">
        {ms != null ? (
          <span className="absolute top-1/2 h-4 w-4 -translate-x-1/2 -translate-y-1/2 rounded-full border-[3px] border-white bg-heading-color shadow-md transition-[left] duration-700 ease-out dark:border-[#0f1428]" style={{ left: `${position}%` }} />
        ) : null}
      </div>
      <div className="relative mt-1.5 h-3 font-mono text-[10px] text-label-muted">
        <span className="absolute left-0">0</span>
        <span className="absolute left-[10%] -translate-x-1/2">300ms</span>
        <span className="absolute left-[33.3%] -translate-x-1/2">1s</span>
        <span className="absolute right-0">3s+</span>
      </div>
    </div>
  );
}
